import React from 'react'
import './range-selector.css'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import ReactTooltip from 'react-tooltip'

class CustomRangePicker extends React.Component {
    render() {
        const {
            customClassName,
            range: { startDate, endDate }
        } = this.props
        return (
            <button data-tip data-for="customBtnTooltip" className={`border-button inlinebuttons ${customClassName}`} onClick={this.props.onClick}>
                {startDate && endDate ? `${startDate.format('DD/MM/YYYY')} - ${endDate.format('DD/MM/YYYY')}` : 'custom range'}
            </button>
        )
    }
}

export class RangeSelectorBuyers extends React.Component {
    state = {
        type: this.props.range.type,
        startDate: this.props.range.startDate,
        endDate: this.props.range.endDate,
        pickMode: 'custom'
    }

    componentDidMount() {
        const { range } = this.props
        this.setState({ ...range }, () =>{
            let maxDate = moment()
            if (this.props.maxDate) {
                maxDate = this.props.maxDate
            }
            this.setState({ maxDate: maxDate }, () => {
                console.log('datepicker maxdate ', this.state.maxDate)
            })

            console.log('picker date init', this.state)
        })
        
    }

    handleDateChange(date) {
        console.log('picker handleDateChange ', date, this.state)
        if (this.state.pickMode === 'start') {
            this.setState({
                startDate: date,
                pickMode: 'end'
            })
        } else {
            if (date.isBefore(this.state.startDate)) {
                this.setState({
                    startDate: date,
                    endDate: this.state.startDate,
                    pickMode: 'start'
                })
                this.props.onChangeRange({
                    type: 'custom',
                    startDate: date,
                    endDate: this.state.startDate
                })
            } else {
                this.setState({
                    endDate: date,
                    pickMode: 'start'
                })
                this.props.onChangeRange({
                    type: 'custom',
                    startDate: this.state.startDate,
                    endDate: date
                })
            }
        }
    }

    render() {
        const { onChangeRange } = this.props
        const selected = this.props.range.type
        const clazz = range => (selected === range ? 'selected' : '')

        return (
            <div className="range-selector range-selector-row">
                <ReactTooltip id="customBtnTooltip" type="dark" effect="solid">
                    <span>Filter by custom date range</span>
                </ReactTooltip>
                <ReactTooltip id="lastmonthBtnTooltip" type="dark" effect="solid">
                    <span>Filter by last month</span>
                </ReactTooltip>
                <ReactTooltip id="thismonthBtnTooltip" type="dark" effect="solid">
                    <span>Filter by the current month</span>
                </ReactTooltip>

                <p style={{'margin-bottom': '10px'}}>Date</p>

                <DatePicker
                    customInput={<CustomRangePicker customClassName={clazz('custom')} {...this.props} />}
                    selectsStart={this.state.pickMode === 'start'}
                    selectsEnd={this.state.pickMode === 'end'}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    maxDate={this.state.maxDate}
                    className="form-control"
                    shouldCloseOnSelect={this.state.pickMode === 'end'}
                    onChange={e => this.handleDateChange(e)}
                />
                
                
            </div>
        )
    }
}
